import { render, staticRenderFns } from "./ImageProcessing.vue?vue&type=template&id=97d9aca0&scoped=true"
import script from "./ImageProcessing.vue?vue&type=script&lang=js"
export * from "./ImageProcessing.vue?vue&type=script&lang=js"
import style0 from "./ImageProcessing.vue?vue&type=style&index=0&id=97d9aca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d9aca0",
  null
  
)

export default component.exports